import { ALERT_ICON_PATH, BACK_ICON_PATH, T_LOGO_ICON_PATH } from '@/consts/imgPath';
import * as ViewModel from '@/core/presenter/viewModel/viewTypes';
import { useCallback } from 'react';

interface IProps {
  title: string;
  settingViewType: ViewModel.SettingViewType;
  onChangeSettingViewType: (viewType: ViewModel.SettingViewType) => void;
}

const SettingViewHeader = ({ title, settingViewType, onChangeSettingViewType }: IProps) => {
  const handleChangeSettingViewType = useCallback(() => {
    if (settingViewType === ViewModel.SettingViewType.PWD_SETTING)
      onChangeSettingViewType(ViewModel.SettingViewType.MAIN);
    if (settingViewType === ViewModel.SettingViewType.CHECK_PWD_SETTING)
      onChangeSettingViewType(ViewModel.SettingViewType.PWD_SETTING);
    if (settingViewType === ViewModel.SettingViewType.EXIT) onChangeSettingViewType(ViewModel.SettingViewType.MAIN);
  }, [onChangeSettingViewType, settingViewType]);
  return (
    <div className="container">
      <header className="ili-header sticky-header">
        {settingViewType !== ViewModel.SettingViewType.MAIN && (
          <a className="back-area" onClick={handleChangeSettingViewType}>
            <img src={BACK_ICON_PATH} alt="back-icon" />
          </a>
        )}
        <a className="inner" href="#">
          <div className="img">
            <img src={T_LOGO_ICON_PATH} alt="Logo" />
          </div>
          <h2>{title}</h2>
        </a>
        <div className="icon-area">
          <img src={ALERT_ICON_PATH} alt="alert-icon" style={{ opacity: 0 }} />
        </div>
      </header>
    </div>
  );
};

export default SettingViewHeader;
